import { Component, OnInit } from '@angular/core';
import { PatientDataService } from '../../data-services/patient.service';
import { SelectItem } from 'primeng/api';
import { FormsModule } from '@angular/forms';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { SelectModule } from 'primeng/select';
import { DatePickerModule } from 'primeng/datepicker';
import { AutocompleteComponent } from '../address/google-places.component';

@Component({
   selector: 'app-patient-add',
   styleUrls: ['./patient.add.css'],
   templateUrl: './patient.add.html',
   imports: [FormsModule, SelectModule, DatePickerModule, AutocompleteComponent]
})
export class PatientAddComponent implements OnInit {

   constructor(private patientDataService: PatientDataService, public ref: DynamicDialogRef, public config: DynamicDialogConfig) {
   }

   requisition = {};
   loading: boolean;
   genders: SelectItem[];
   ethnicities: SelectItem[];
   states: SelectItem[];
   patient: any;
   editmode: boolean = true;
   id: any;

   ngOnInit() {
      this.loading = true;

      this.genders = [
         { label: '', value: '' },
         { label: 'Male', value: 'M' },
         { label: 'Female', value: 'F' },
         { label: 'Undecided', value: 'U' }
      ];

      this.ethnicities = [
         { label: '', value: '' },
         { label: 'White', value: 'W' },
         { label: 'Brown', value: 'R' },
         { label: 'Black', value: 'B' },
         { label: 'Polka Dotted', value: 'P' }
      ];

      this.states = [
         { label: '', value: '' },
         { label: 'AK', value: 'AK' },
         { label: 'AL', value: 'AL' },
         { label: 'AR', value: 'AR' },
         { label: 'CA', value: 'CA' }
      ];

      //id: this.config.id
      //this.getPatient(this.config.data.id);
      this.patient = this.config.data.patient;
   }

   public getPatient(patientid) {
      this.id = patientid;

      if (this.id == 0) {
         this.patientDataService.getEmptyModel().subscribe((data: any) => {
            this.patient = data;
            this.editmode = true;
            this.patient.PatientAddresses = [];
            this.patient.WorkAddress = {};
            this.patient.HomeAddress = {};
            console.log(JSON.stringify(this.patient));
         });
      }
      else {
         this.patientDataService.getPatient(this.id).subscribe((data: any) => {
            this.patient = data;
            console.log(JSON.stringify(this.patient));
         });
      }
   }

   public savePatient() {
      //this.patientDataService.save(this.patient).subscribe((data: any) => {
      //   console.log('Patient Saved!');
      //   this.saveComplete();
      //});

      //bypassing the patient save and sending it up to be saved by parent
      this.saveComplete();
   }

   saveComplete() {
      this.editmode = false;
      this.ref.close(this.patient);
   }

   public toggleEdit() {
      this.editmode = !this.editmode;
      this.ref.close();
   }


}
